//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Builder.js";
import "../Drawings/Drawings.HiddenObjectsBuilder.js";
import "../Drawings/Drawings.ParentViewBuilder.js";
import "../Drawings/Drawings.ViewPlacementBuilder.js";
import "../Drawings/Drawings.DraftingComponentSelectionBuilder.js";
import "../Drawings/Drawings.ViewStyleBuilder.js";
let d=[[[1,"HiddenObjects",0,"Drawings.HiddenObjectsBuilder",0],[1,"NonSectionedObjects",0,"Drawings.HiddenObjectsBuilder",0],[1,"Parent",0,"Drawings.ParentViewBuilder",0],[1,"Placement",0,"Drawings.ViewPlacementBuilder",0],[1,"SecondaryComponents",0,"Drawings.DraftingComponentSelectionBuilder",0],[1,"Style",0,"Drawings.ViewStyleBuilder",0]],[[[],"CreatePreviewView",{R_:{projectedViewPreview:"Drawings.ProjectedView"}},0,0]],[]];
SPLM.Drawings.ProjectedViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ProjectedViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;